export enum SiteActionTypes {
  LOAD_SITE = 'site/LOAD_SITE',
}

export interface SiteInterface {
  loaded: boolean;
}
